import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { AppMetadataHandler } from 'app/BaseFramework/configs';
@Injectable()
export class DynamicRenderingService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private appMetadataHandler : AppMetadataHandler
    ) { }

    getUIMetaData(product) {
        let riderListSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        //let metaDataServiceURL = 'api/productMetadata/fetchBasePlanMetadata/' + product;
        let metaDataServiceURL = `apiProductMetadata/${product}/entity/${this.appMetadataHandler.entityCd}`;
        let DataList: any[] = [];
        this.apiRequest.getCallWithAPIMapper(metaDataServiceURL)
            .subscribe(jsonResp => {
                console.log("=============Meta Data===============")
                console.log(jsonResp);
                if (Array.isArray(jsonResp)) {
                jsonResp.forEach(element => {
                    DataList.push(element);
                });}

                riderListSubject.next(DataList);
                riderListSubject.complete();

            },
            errResp => {
                console.log("POST ERROR")
                riderListSubject.next(DataList);
            })


        return riderListSubject;

    }

}
